module.exports = __webpack_public_path__ + "static/media/ok.af06c109.svg";